import { render } from "./course.vue?vue&type=template&id=501973aa&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"

import "./course.vue?vue&type=style&index=0&id=501973aa&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\jll-web-xintan\\official-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501973aa"]])

export default __exports__